<template>
  <div>
    <CustomFdkAccount v-slot="accountsData">
      <JdsButtonGroup>
        <JdsButton
          variant="tertiary"
          size="small"
          @click="updateVoteCount(accountsData, 'upvote')"
          className="fe-text-body-xxs lg:fe-text-body-xs"
          :disabled="disabled"
        >
          <template #icon>
            <JdsIcon
              name="UpvoteIcon"
              smSize="s"
              lgSize="m"
              :color="
                upvoteSelected
                  ? 'fe-text-success-50'
                  : 'fe-text-primary-grey-80'
              "
            />
          </template>
          <span class="fe-text-primary-grey-80 fe-pl-xs">
            {{ getFormattedNumber(answerObj.upvoteCount) }}
          </span>
        </JdsButton>

        <JdsButton
          variant="tertiary"
          size="small"
          @click="updateVoteCount(accountsData, 'downvote')"
          className="fe-text-body-xxs lg:fe-text-body-xs"
          :disabled="disabled"
        >
          <template #icon>
            <JdsIcon
              name="DownvoteIcon"
              smSize="s"
              lgSize="m"
              :color="
                downvoteSelected
                  ? 'fe-text-error-50'
                  : 'fe-text-primary-grey-80'
              "
            />
            <span class="fe-text-primary-grey-80 fe-pl-xs">
              {{ getFormattedNumber(answerObj.downvoteCount) }}
            </span>
          </template>
        </JdsButton>
      </JdsButtonGroup>
    </CustomFdkAccount>
  </div>
</template>

<script>
  import JdsButtonGroup from "@/components/DesignSystem/JdsButtonGroup/JdsButtonGroup.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import { apiUpdateVoteCount } from "@/api_service/qnaApi"

  import { formatToReadableNumber } from "@/utils/utils"

  export default {
    name: "QnAVote",
    components: {
      JdsButton,
      JdsIcon,
      JdsButtonGroup,
      CustomFdkAccount,
    },
    props: {
      answer: {
        type: Object,
        default: () => {},
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        upvoteSelected: false,
        downvoteSelected: false,
        answerObj: this.answer,
      }
    },
    methods: {
      async updateVoteCount(accountsData, voteType) {
        try {
          if (!accountsData.is_logged_in) {
            accountsData.openLogin()
            return
          }

          // User can upvote/downvote only once in one browser session, so using this flag
          if (
            (voteType === "upvote" && this.upvoteSelected) ||
            (voteType === "downvote" && this.downvoteSelected)
          ) {
            return
          }

          const queryParam = {
            contentId: this.answerObj.id,
            vote: voteType.toUpperCase(),
          }

          const response = await apiUpdateVoteCount(queryParam)

          if (response.resultInfo.status === "SUCCESS") {
            /**
             * NOTE: Updating props directly is an VUE ANTI-PATTERN.
             * But in our case, since, we have no interactivity in Answer List, it is working fine.
             * And it is lot more easier to do this way instead updating global state.
             * So we have used prop modify approach to make things simpler.
             */
            if (voteType === "upvote") {
              // eslint-disable-next-line
              this.answerObj.upvoteCount =
                parseInt(this.answerObj.upvoteCount) + 1

              if (this.downvoteSelected) {
                this.answerObj.downvoteCount = this.answerObj.downvoteCount - 1
                this.downvoteSelected = false
              }
              this.upvoteSelected = true
            } else {
              // eslint-disable-next-line
              this.answerObj.downvoteCount =
                parseInt(this.answerObj.downvoteCount) + 1

              if (this.upvoteSelected) {
                this.answerObj.upvoteCount = this.answerObj.upvoteCount - 1
                this.upvoteSelected = false
              }
              this.downvoteSelected = true
            }
          }
        } catch (err) {
          console.error(err)
        }
      },
      getFormattedNumber(count) {
        if (!count) {
          return 0
        }
        return formatToReadableNumber(count)
      },
    },
  }
</script>
